"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PointRestriction_viewport, _PointRestriction_point, _PointRestriction_radius, _PointRestriction_settings, _PointRestriction_snapRestrictions, _PointRestriction_visualizationObject, _PointRestriction_wireframe, _PointRestriction_wireframeColor, _PointRestriction_wireframeDepthTest, _PointRestriction_wireframePointSize;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointRestriction = void 0;
const viewer_1 = require("@shapediver/viewer");
const gl_matrix_1 = require("gl-matrix");
const THREE = __importStar(require("three"));
const AbstractRestriction_1 = require("../AbstractRestriction");
let pointTexture = viewer_1.MaterialEngine.instance
    .loadMap("https://viewer.shapediver.com/v3/graphics/point_soft.png")
    .then((mapData) => {
    pointTexture = new THREE.Texture(mapData.image);
    pointTexture.needsUpdate = true;
    return pointTexture;
});
// #endregion Type aliases (1)
// #region Classes (1)
class PointRestriction extends AbstractRestriction_1.AbstractRestriction {
    // #endregion Properties (8)
    // #region Constructors (1)
    constructor(viewport, geometryMathManager, parentNode, id, settings, properties) {
        var _a, _b, _c, _d, _e;
        super(viewport, parentNode, id, properties);
        // #region Properties (8)
        _PointRestriction_viewport.set(this, void 0);
        _PointRestriction_point.set(this, void 0);
        _PointRestriction_radius.set(this, void 0);
        _PointRestriction_settings.set(this, void 0);
        _PointRestriction_snapRestrictions.set(this, {});
        _PointRestriction_visualizationObject.set(this, new THREE.Object3D());
        _PointRestriction_wireframe.set(this, void 0);
        _PointRestriction_wireframeColor.set(this, void 0);
        _PointRestriction_wireframeDepthTest.set(this, void 0);
        _PointRestriction_wireframePointSize.set(this, 1);
        __classPrivateFieldSet(this, _PointRestriction_viewport, viewport, "f");
        __classPrivateFieldSet(this, _PointRestriction_point, properties.point, "f");
        __classPrivateFieldSet(this, _PointRestriction_radius, properties.radius || 0, "f");
        __classPrivateFieldSet(this, _PointRestriction_settings, settings, "f");
        __classPrivateFieldSet(this, _PointRestriction_wireframe, (_b = (_a = properties.wireframe) !== null && _a !== void 0 ? _a : settings.wireframe) !== null && _b !== void 0 ? _b : true, "f");
        __classPrivateFieldSet(this, _PointRestriction_wireframeColor, (_d = (_c = properties.wireframeColor) !== null && _c !== void 0 ? _c : settings.wireframeColor) !== null && _d !== void 0 ? _d : settings.points.color_1, "f");
        __classPrivateFieldSet(this, _PointRestriction_wireframePointSize, properties.wireframePointSize
            ? properties.wireframePointSize * __classPrivateFieldGet(this, _PointRestriction_viewport, "f").pointSize
            : 10 * __classPrivateFieldGet(this, _PointRestriction_viewport, "f").pointSize, "f");
        __classPrivateFieldSet(this, _PointRestriction_wireframeDepthTest, (_e = properties.wireframeDepthTest) !== null && _e !== void 0 ? _e : false, "f");
        if (__classPrivateFieldGet(this, _PointRestriction_wireframe, "f")) {
            const geometry = new THREE.BufferGeometry();
            geometry.setAttribute("position", new THREE.Float32BufferAttribute([__classPrivateFieldGet(this, _PointRestriction_point, "f")[0], __classPrivateFieldGet(this, _PointRestriction_point, "f")[1], __classPrivateFieldGet(this, _PointRestriction_point, "f")[2]], 3));
            const height = __classPrivateFieldGet(this, _PointRestriction_viewport, "f").canvas.height;
            const pointSize = __classPrivateFieldGet(this, _PointRestriction_wireframePointSize, "f") * (height / 1080);
            const material = new THREE.PointsMaterial(Object.assign({ color: new THREE.Color(__classPrivateFieldGet(this, _PointRestriction_wireframeColor, "f")), size: pointSize, sizeAttenuation: false, depthTest: __classPrivateFieldGet(this, _PointRestriction_wireframeDepthTest, "f"), depthWrite: !__classPrivateFieldGet(this, _PointRestriction_wireframeDepthTest, "f"), transparent: true }, (pointTexture instanceof THREE.Texture
                ? { map: pointTexture }
                : {})));
            if (pointTexture instanceof Promise) {
                pointTexture.then((texture) => {
                    material.map = texture;
                    material.needsUpdate = true;
                });
            }
            const points = new THREE.Points(geometry, material);
            points.renderOrder = 100;
            points.matrixAutoUpdate = false;
            __classPrivateFieldGet(this, _PointRestriction_visualizationObject, "f").add(points);
            this._object3D.add(__classPrivateFieldGet(this, _PointRestriction_visualizationObject, "f"));
        }
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (4)
    get point() {
        return __classPrivateFieldGet(this, _PointRestriction_point, "f");
    }
    get radius() {
        return __classPrivateFieldGet(this, _PointRestriction_radius, "f");
    }
    get snapRestrictions() {
        return __classPrivateFieldGet(this, _PointRestriction_snapRestrictions, "f");
    }
    // #endregion Public Getters And Setters (4)
    // #region Public Methods (1)
    isWithinRadius(point) {
        return (gl_matrix_1.vec3.squaredDistance(point, __classPrivateFieldGet(this, _PointRestriction_point, "f")) <=
            __classPrivateFieldGet(this, _PointRestriction_radius, "f") * __classPrivateFieldGet(this, _PointRestriction_radius, "f"));
    }
    rayTrace(ray, metaData) {
        const closestPointVector = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _PointRestriction_point, "f"), ray.origin);
        const t = Math.max(0, gl_matrix_1.vec3.dot(closestPointVector, ray.direction));
        const closestPoint = gl_matrix_1.vec3.create();
        gl_matrix_1.vec3.scaleAndAdd(closestPoint, ray.origin, ray.direction, t);
        const distance = gl_matrix_1.vec3.squaredDistance(closestPoint, __classPrivateFieldGet(this, _PointRestriction_point, "f"));
        if (distance < __classPrivateFieldGet(this, _PointRestriction_radius, "f") * __classPrivateFieldGet(this, _PointRestriction_radius, "f")) {
            // check if origin is inside the sphere
            const distanceOrigin = gl_matrix_1.vec3.squaredDistance(ray.origin, __classPrivateFieldGet(this, _PointRestriction_point, "f"));
            if (distanceOrigin < __classPrivateFieldGet(this, _PointRestriction_radius, "f") * __classPrivateFieldGet(this, _PointRestriction_radius, "f")) {
                return {
                    closestIntersectionPoint: closestPoint,
                    distanceOriginToClosestIntersectionPointSquared: distanceOrigin,
                    targetPoint: __classPrivateFieldGet(this, _PointRestriction_point, "f"),
                    distanceClosestPointToTargetPointSquared: distance,
                    restriction: this,
                };
            }
            // now we calculate the closest point on the sphere to the ray
            const offset = Math.sqrt(__classPrivateFieldGet(this, _PointRestriction_radius, "f") * __classPrivateFieldGet(this, _PointRestriction_radius, "f") - distance);
            // Compute the entry distance
            const entry = t - offset;
            const closestIntersectionPoint = gl_matrix_1.vec3.scaleAndAdd(gl_matrix_1.vec3.create(), ray.origin, ray.direction, entry);
            return {
                closestIntersectionPoint: closestIntersectionPoint,
                distanceOriginToClosestIntersectionPointSquared: entry * entry,
                targetPoint: __classPrivateFieldGet(this, _PointRestriction_point, "f"),
                distanceClosestPointToTargetPointSquared: distance,
                restriction: this,
            };
        }
        return;
    }
    // #endregion Public Methods (1)
    // #region Protected Methods (1)
    visibilityChanged() { }
}
exports.PointRestriction = PointRestriction;
_PointRestriction_viewport = new WeakMap(), _PointRestriction_point = new WeakMap(), _PointRestriction_radius = new WeakMap(), _PointRestriction_settings = new WeakMap(), _PointRestriction_snapRestrictions = new WeakMap(), _PointRestriction_visualizationObject = new WeakMap(), _PointRestriction_wireframe = new WeakMap(), _PointRestriction_wireframeColor = new WeakMap(), _PointRestriction_wireframeDepthTest = new WeakMap(), _PointRestriction_wireframePointSize = new WeakMap();
// #endregion Classes (1)
//# sourceMappingURL=PointRestriction.js.map